import * as environments from 'src/environments.json';
const env = environments.default[process.env.REACT_APP_ENVIRONMENT.trim()];

const USE_CASE_URL = 'customer-contracts';

const downloadContractDocumentPdfByIndex = ({
  customerContractId,
  documentIndex
}) => {
  const url = `${env.api.url}/${USE_CASE_URL}/download/document?customerContractId=${customerContractId}&documentIndex=${documentIndex}`;

  window.location = url;
};

export default downloadContractDocumentPdfByIndex;
